// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__1qEta","upload":"Small_upload__1gLcu","imageWrap":"Small_imageWrap__27bxg","removeBtn":"Small_removeBtn__fUAMB"};